export default "__VITE_ASSET__C$MxL7_E__"